import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { filter, map } from 'rxjs/operators';
import { BackendService } from './core/services/backend-prod.service';
import { HelperService } from './core/services/helper.service';
import { SessionService } from './core/services/session.service';
import { environment } from 'src/environments/environment';
import {CookieService} from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  currentVersion: string = '';
  isVendor: boolean = false;
  copilot: boolean = false;
  private channel: BroadcastChannel | undefined;

  constructor(
    private title: Title,
    private platform: Platform,
    public router: Router,
    private backendService: BackendService,
    public helperService: HelperService,
    public sessionService: SessionService,
    public storage: Storage,
    private cookieService:CookieService,
    private http: HttpClient
  ) {
      
    this.getStorage().then((res)=>{
      if(res.csrf_token){
        helperService.csrf_token=res.csrf_token;
        cookieService.set('csrf_access_token',res.csrf_token,{sameSite:'None',secure:true});
      }else{
        this.backendService.PostExternalAPICall(`${environment.node_api_base_url}/api/csrf_token`,'').subscribe((token)=>{
          helperService.csrf_token=token.csrf_token;
          storage.set('csrf_token',token.csrf_token);
          cookieService.set('csrf_access_token',token.csrf_token,{sameSite:'None',secure:true})
        })
      }
    })
    this.initializeApp();
  }

  ngOnInit() {
    this.title.setTitle('eZintegrations');

    // if (this.swUpdate.isEnabled) {
    //   this.startCheckingForUpdate();
    //   this.listenForVersionUpdates();
    //   this.setupBroadcastChannel();
    // };
  }

  // startCheckingForUpdate() {
  //   setInterval(() => {
  //     const checkForUpdates = () => {
  //       this.swUpdate.checkForUpdate().then(() => {
  //       }).catch(err => {
  //         console.error('Error checking for updates:', err);
  //       });
  //     };
  //     checkForUpdates();
  //   }, 5000); 
  // };

  // // Listen for version updates from SwUpdate (Angular's Service Worker)
  // listenForVersionUpdates() {
  //   this.swUpdate.versionUpdates.subscribe((event) => {
  //     if (event.type === 'VERSION_READY') {
  //       // Post message to BroadcastChannel so all tabs can know about the update
  //       if (this.channel) {
  //         this.channel.postMessage('update');
  //       }
  //       this.promptUserForUpdate();
  //     }
  //   });
  // };

  // // Initialize BroadcastChannel for communication between tabs
  // setupBroadcastChannel() {
  //   if ('BroadcastChannel' in window) {
  //     this.channel = new BroadcastChannel('update-channel');
  //     this.channel.onmessage = (message) => {
  //       if (message.data === 'update') {
  //         this.promptUserForUpdate();
  //       }
  //     };
  //   };
  // };

  // // Prompt the user for an update when a new version is ready
  // promptUserForUpdate() {
  //   const updateConfirmed = confirm('A new version of the app is available. Do you want to update now?');
  //   if (updateConfirmed) {
  //     this.clearCache();
  //     this.swUpdate.activateUpdate().then(() => {
  //       window.location.reload();
  //     }).catch(err => {
  //       console.error('Error during update activation:', err);
  //     });
  //   } else {
  //     console.log('User declined to update');
  //   }
  // };

  // // Clear the cache manually (optional)
  // clearCache() {
  //   if ('caches' in window) {
  //     caches.keys().then(cacheNames => {
  //       cacheNames.forEach(cacheName => {
  //         caches.delete(cacheName).then(() => {
  //           console.log(`Cache ${cacheName} cleared.`);
  //         });
  //       });
  //     });
  //   };
  // };



  initializeApp() {
    this.platform.ready().then(() => {
      this.sessionService.getStorageDetails();

      this.router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          map(() => {
            let route: ActivatedRoute = this.router.routerState.root;
            //console.log(this.router.url.startsWith('/vendor'));
            this.isVendor = this.router.url.startsWith('/vendor');
            let routeTitle = '';
            while (route!.firstChild) {
              route = route.firstChild;
            }
            if (route.snapshot.data['title']) {
              routeTitle = route!.snapshot.data['title'];
            }
            return routeTitle;
          })
        )
        .subscribe((title: string) => {
          if (title) {
            let getUrl = this.helperService.getUrl();
            //console.log(getUrl);
            this.logUserActivity(getUrl, title)
            // //console.log(`You opened ${title}`);
          }
          if (this.helperService.getUrl().includes('integration') && !this.helperService.getUrl().includes('%2F') && !this.helperService.getUrl().includes('stream-logs')) {
            this.http.get('assets/feature_switching.json').subscribe((res: any) => {
              this.copilot = res.co_pilot;
            })
          } else {
            this.copilot = false;
          }
        });
    });
  }

  async getStorage() {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id"),
      csrf_token: await this.storage.get('csrf_token')
    }
    return data;
  }

  logUserActivity(pageUrl, pageName) {
    this.getStorage().then((res) => {
      let payload = {
        user_id: res.userId,
        visited_page_url: pageUrl,
        action: pageName
      }

      this.backendService.PostAPICall('setActivity', payload, res.token).subscribe((res) => {
        //console.log(res);
      })
    })
  }
}

